// Functional component used for customizing the menu icon in selectors - created as ts functional component to allow use in ts file for default props

import { createVNode } from 'vue';
import { VIcon } from 'vuetify/components';

export default {
  render() {
    return createVNode(VIcon, {
      icon: 'fas fa-chevron-down',
      class: 'text-body-3 text-fontSecondary'
    });
  }
};
